// extracted by mini-css-extract-plugin
module.exports = {"modal":"ForumModal_modal__3kYgu","card":"ForumModal_card__3BLxD","sending":"ForumModal_sending__2oQSy"};